"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AlertDiamond: ['alert-diamond', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,10.586,13.414,1a2,2,0,0,0-2.828,0L1,10.587a2,2,0,0,0,0,2.828H1L10.586,23a2,2,0,0,0,2.828,0L23,13.415A2,2,0,0,0,23,10.586ZM11.068,6.417a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0Zm1.051,11.51h-.028a1.529,1.529,0,0,1-1.522-1.47,1.475,1.475,0,0,1,1.448-1.53h.028a1.527,1.527,0,0,1,1.522,1.47A1.475,1.475,0,0,1,12.119,17.927Z']],
  AlertTriangle: ['alert-triangle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.119,20,13.772,2.15h0a2,2,0,0,0-3.543,0L.881,20a2,2,0,0,0,1.772,2.928H21.347A2,2,0,0,0,23.119,20ZM11,8.423a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Zm1.05,11.51h-.028a1.528,1.528,0,0,1-1.522-1.47,1.476,1.476,0,0,1,1.448-1.53h.028A1.527,1.527,0,0,1,13.5,18.4,1.475,1.475,0,0,1,12.05,19.933Z']],
  StopSign: ['stop-sign', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.008,16.164A1.988,1.988,0,0,0,.6,17.581l5.849,5.825a1.989,1.989,0,0,0,1.409.583h0L16.065,24a1.987,1.987,0,0,0,1.4-.575l5.93-5.84a2.01,2.01,0,0,0,.6-1.424v-8.2a1.984,1.984,0,0,0-.583-1.41L17.489.6a1.989,1.989,0,0,0-1.418-.59h-8.2A2.013,2.013,0,0,0,6.446.6L.579,6.56A1.989,1.989,0,0,0,0,7.964Zm8-9.29v0a.931.931,0,0,1,1.82-.39l.946,4.393a.049.049,0,0,0,.054.039.05.05,0,0,0,.045-.05V5.435a.93.93,0,0,1,1.86,0v5.446a.051.051,0,0,0,.045.05.049.049,0,0,0,.054-.039l.946-4.186h0A.931.931,0,0,1,15.6,7.1v0l-.957,5.219a.051.051,0,0,0,.031.056.052.052,0,0,0,.061-.02l1.55-2.441h0a.931.931,0,0,1,1.587.972l0,0-1.328,2.494a3.347,3.347,0,0,0-.394,1.579c0,2.093-.586,3.814-2.79,3.815H11.182a2.8,2.8,0,0,1-2.019-.862l0,0L5.9,13.571,5.9,13.565a.931.931,0,0,1,1.26-1.371h0l1.751,1.529a.05.05,0,0,0,.082-.045Z']],
  InformationCircle: ['information-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z']],
  RadioactiveCircle: ['radioactive-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,10.005A1.995,1.995,0,1,1,10.005,12,2,2,0,0,1,12,10.006ZM7.533,12,4.021,12a.486.486,0,0,1-.363-.152.529.529,0,0,1-.138-.379A8.472,8.472,0,0,1,7.3,4.922a.564.564,0,0,1,.4-.07.533.533,0,0,1,.313.238L9.768,8.132a.487.487,0,0,1-.121.638,3.963,3.963,0,0,0-1.621,2.809A.489.489,0,0,1,7.533,12Zm8.507,7.3a.533.533,0,0,1-.26.31,8.472,8.472,0,0,1-7.56,0,.565.565,0,0,1-.26-.31.532.532,0,0,1,.05-.39l1.755-3.042a.487.487,0,0,1,.613-.215,3.964,3.964,0,0,0,3.244,0,.487.487,0,0,1,.613.215l1.755,3.042A.488.488,0,0,1,16.04,19.3Zm4.3-7.452a.527.527,0,0,1-.363.152l-3.512,0a.489.489,0,0,1-.493-.424A3.963,3.963,0,0,0,14.353,8.77a.487.487,0,0,1-.121-.638L15.989,5.09a.491.491,0,0,1,.313-.238.533.533,0,0,1,.4.07,8.472,8.472,0,0,1,3.78,6.548A.557.557,0,0,1,20.342,11.849Z']],
  QuestionCircle: ['question-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z']],
  Radioactive: ['radioactive', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.514,21.79a1,1,0,0,0,.5-.6l0-.01a.966.966,0,0,0-.1-.777l-3.01-5.22A.5.5,0,0,0,14.228,15a4.415,4.415,0,0,1-4.452-.006.5.5,0,0,0-.689.179l-3,5.212a.983.983,0,0,0-.106.8,1,1,0,0,0,.5.6,11.993,11.993,0,0,0,11.035,0Z', 'M18.477,1.036A1,1,0,0,0,17.7.9a1.011,1.011,0,0,0-.64.477l-3.01,5.22a.5.5,0,0,0,.182.682,4.539,4.539,0,0,1,2.241,3.858c0,.151-.009.294-.019.471a.5.5,0,0,0,.5.529h6.04a1.033,1.033,0,0,0,.732-.316,1.062,1.062,0,0,0,.268-.7v-.022A12.94,12.94,0,0,0,18.477,1.036Z', 'M6.942,1.371A1.01,1.01,0,0,0,6.3.9a.987.987,0,0,0-.777.138A12.949,12.949,0,0,0,.01,11.113a1.076,1.076,0,0,0,.287.724,1.02,1.02,0,0,0,.713.3H7.05a.513.513,0,0,0,.363-.17.531.531,0,0,0,.134-.385c-.008-.151-.017-.294-.017-.445A4.539,4.539,0,0,1,9.771,7.275a.5.5,0,0,0,.182-.682Z', 'M9.500 11.133 A2.500 2.500 0 1 0 14.500 11.133 A2.500 2.500 0 1 0 9.500 11.133 Z']],
  AlertMessageLaptop: ['alert-message-laptop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,20.5a.5.5,0,0,0-.5-.5H21.75a.25.25,0,0,1-.25-.25V15.5a1,1,0,1,0-2,0v4.25a.25.25,0,0,1-.25.25H4.75a.25.25,0,0,1-.25-.25V9.167A.667.667,0,0,1,5.167,8.5H7.5a1,1,0,1,0,0-2H5.167A2.669,2.669,0,0,0,2.5,9.167V19.751a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5A3.5,3.5,0,0,0,3.5,24h17A3.5,3.5,0,0,0,24,20.5Z', 'M10.5,14a.51.51,0,0,0,.215-.048L14.1,12.34a.25.25,0,0,1,.226.006A6.564,6.564,0,1,0,17.434,0,6.432,6.432,0,0,0,11,6.568a6.665,6.665,0,0,0,.659,3.106.253.253,0,0,1,0,.223l-1.614,3.389A.5.5,0,0,0,10.5,14ZM18.25,4V7a.75.75,0,1,1-1.5,0V4a.75.75,0,0,1,1.5,0ZM17.5,8.5a.75.75,0,1,1-.75.75A.75.75,0,0,1,17.5,8.5Z']],
  AlertUser: ['alert-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.929,4.079a.251.251,0,0,0-.035-.225.249.249,0,0,0-.2-.1H3.5A3,3,0,0,0,.5,6.7c0,.017,0,16.052,0,16.052a1,1,0,0,0,2,0V8.251a.5.5,0,0,1,.5-.5H8.282a.25.25,0,0,0,.249-.272C8.511,7.239,8.5,7,8.5,6.751A8.493,8.493,0,0,1,8.929,4.079Z', 'M15,22.751a1,1,0,1,0,2,0V15.5a.251.251,0,0,0-.243-.25A8.518,8.518,0,0,1,15.3,15.08a.251.251,0,0,0-.3.245Z', 'M16.934,13.384a6.567,6.567,0,0,0,0-13.133A6.432,6.432,0,0,0,10.5,6.818a6.665,6.665,0,0,0,.659,3.106.253.253,0,0,1,0,.223l-.87,1.826-.744,1.563a.5.5,0,0,0,.451.715.51.51,0,0,0,.215-.048l1.563-.745L13.6,12.59a.25.25,0,0,1,.226.006A6.534,6.534,0,0,0,16.934,13.384Zm.816-9.133v3a.75.75,0,1,1-1.5,0v-3a.75.75,0,0,1,1.5,0Zm0,5.25a.75.75,0,1,1-.75-.75A.75.75,0,0,1,17.75,9.5Z', 'M6.670 17.251 A2.000 2.000 0 1 0 10.670 17.251 A2.000 2.000 0 1 0 6.670 17.251 Z', 'M11.964,22.568A3.594,3.594,0,0,0,8.67,20.251a3.594,3.594,0,0,0-3.294,2.317.5.5,0,0,0,.47.683h5.647A.5.5,0,0,0,11.964,22.568Z']],
  AlertCircle: ['alert-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z']]
};
exports["default"] = _default;